var React = require('react');

function LegendPartnerStates (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"map legend icon for partner states"),React.createElement("rect",{"fill":"#E11D38","x":"0","y":"0","width":"27","height":"16","key":1})]);
}

LegendPartnerStates.defaultProps = {"width":"27px","height":"16px","viewBox":"0 0 27 16"};

module.exports = LegendPartnerStates;

LegendPartnerStates.default = LegendPartnerStates;



//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/legend-partner-states.svg
// module id = 937
// module chunks = 35783957827783